<template>
  <div class="wrapper">
    <div class="block">
      <el-form
          ref="form"
          :model="form"
          :rules="rules"
          v-loading="isBusy"
          element-loading-spinner="el-icon-loading"
          :inline="true"
      >
        <el-form-item prop="send_at">
          <el-date-picker
              v-model="form.send_at"
              type="datetime"
              placeholder="Select date and time"
              :format="dateFormat"
              :firstDayOfWeek="1"
              :value-format="formDateFormat"
          >
          </el-date-picker>
        </el-form-item>
        <button type="button" class="btn btn-outline-secondary align-top" @click="cancel">Cancel</button>
        <button type="button" class="btn btn-primary align-top" @click="store">Schedule Message</button>
      </el-form>
    </div>
  </div>
</template>

<script>
import ValidatorMixin from "../../../mixins/validator";

export default {
  props: {
    model: {
      type: Object,
      default: function () {
        return {};
      },
    },
    storePendingMessageUrl: String,
    conversationId: Number,
  },

  data() {
    const form = {
      conversation_id: null,
      content: null,
      media: null,
      send_at: null,
    };

    return {
      form,
      rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
      isBusy: false,
    };
  },

  watch: {
    model: {
      handler: function (value) {
        this.initForm(value);
      },
      immediate: true,
    },
  },

  computed: {
    /**
     * @return {String}
     */
    dateFormat() {
      return config('format.element.short.datetime');
    },

    /**
     * @return {String}
     */
    formDateFormat() {
      return config('format.datetime');
    },
  },

  methods: {
    /**
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },

    /**
     * @return {undefined}
     */
    store() {
      this.isBusy = true;
      axios.post(this.storePendingMessageUrl, this.getForm(), {})
          .then(this.storeSuccess)
          .catch(this.handleErrorResponse)
          .then((isBusy = false) => this.isBusy = isBusy);
    },

    /**
     * @param {Object} res
     * @return {boolean}
     */
    storeSuccess({data: {model, message}}) {
      this.$emit('stored', {message: message});
    },

    /**
     * @param {Object} response
     * @return {boolean}
     */
    handleErrorResponse({response: {data, status}}) {
      const {errors, message} = data || {};
      if (status === 422 && errors) {
        this.errors = errors;
        this.$refs.form.validate(() => null);
        this.$message.error(message);
      } else if (message && _.isString(message)) {
        this.$message.error(message);
      }

      return false;
    },

    /**
     * @param {Object} model
     */
    initForm(model) {
      this.form = _.mapValues(this.form, (val, prop) => _.get(model, prop, null));
    },

    /**
     * @return {Object}
     */
    getForm() {
      return _.assign({}, this.form, {_method: 'POST'});
    },
  },

  mixins: [
    ValidatorMixin,
  ],
}
</script>

<style scoped>

</style>
